import React, { Component } from "react";
import { TextField, Button, Typography, Box, CircularProgress } from "@material-ui/core";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
// import { gql } from "graphql-request"; // or your preferred GraphQL client
// import client from "../graphqlClient"; // assume you have a preconfigured graphql client

class InviteTeamMembers extends Component {
  state = {
    emails: [""],
    statuses: [null],
    ids: [""], // null | 'loading' | 'existed' | 'non-exist'
  };

  canSubmit = () => {
    return (
      this.state.statuses.length > 0 &&
      this.state.statuses.every(status => status === "existed")
    );
  };

  handleInputChange = async (index, event) => {
    const newEmails = [...this.state.emails];
    const newStatuses = [...this.state.statuses];

    const value = event.target.value;
    newEmails[index] = value;

    this.setState({ emails: newEmails });

    // If empty → reset
    if (!value) {
      newStatuses[index] = null;
      this.setState({ statuses: newStatuses });
      return;
    }

    // If not a valid email → show "invalid" instead of checking
    if (!this.validateEmail(value)) {
      newStatuses[index] = "invalid";
      this.setState({ statuses: newStatuses });
      return;
    }

    // If valid → run database check
    await this.checkEmail(index, value);
  };


  addEmailField = () => {
    this.setState({
      emails: [...this.state.emails, ""],
      statuses: [...this.state.statuses, null],
    });
  };

  checkEmail = async (index, email) => {
    const newStatuses = [...this.state.statuses];
    const newIds = [...this.state.ids]
    newStatuses[index] = "loading";
    // this.setState({ statuses: newStatuses });

    try {
      let result = await this.props.userByEmail(email)

      newStatuses[index] = result.userByEmail ? "existed" : "non-exist";
      if(result.userByEmail){
        newIds[index] = result.userByEmail._id
      }

      this.setState({ statuses: newStatuses, ids: newIds });
    } catch (err) {
      console.error("GraphQL check error:", err);
      newStatuses[index] = "non-exist"; // fallback
      this.setState({ statuses: newStatuses });
    }
  };

  handleSubmit = () => {
    this.props.inviteMember(this.state.ids);
    // console.log("Inviting:", this.state.emails);
  };

  validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  render() {
    // console.log(this.state)
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        style={{
          backgroundColor: "#f7f7f7",
          padding: "40px",
          height: "100%",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" style={{ marginBottom: 10 }}>
          Add team members
        </Typography>

        <GroupAddIcon style={{ fontSize: 50, color: "#e74c3c", marginBottom: 10 }} />

        <Typography variant="body2" style={{ marginBottom: 20 }}>
          Invite existing members to the team
        </Typography>

        <Box width="100%" maxWidth="400px">
          {this.state.emails.map((email, index) => (
            <Box key={index} display="flex" alignItems="center" style={{ marginBottom: 10 }}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                label={`Email ${index + 1}`}
                value={email}
                onChange={(e) => this.handleInputChange(index, e)}
              />
              <Box ml={2} minWidth="80px">
                {this.state.statuses[index] === "loading" && <CircularProgress size={20} />}
                {this.state.statuses[index] === "existed" && (
                  <Typography style={{ color: "green" }}>Existed</Typography>
                )}
                {this.state.statuses[index] === "non-exist" && (
                  <Typography style={{ color: "red" }}>Non-exist</Typography>
                )}
                {this.state.statuses[index] === "invalid" && (
                  <Typography style={{ color: "orange" }}>Invalid</Typography>
                )}
              </Box>
            </Box>
          ))}

          <Button
            onClick={this.addEmailField}
            variant="outlined"
            color="primary"
            fullWidth
            style={{ marginBottom: 10 }}
          >
            + Add More
          </Button>

          <Button
            onClick={this.handleSubmit}
            variant="contained"
            fullWidth
            disabled={!this.canSubmit()}
            style={{
              backgroundColor: this.canSubmit() ? "#e74c3c" : "#bdbdbd",  // 🔥 red or grey
              color: "#fff",
              cursor: this.canSubmit() ? "pointer" : "not-allowed"
            }}
          >
            Send Invite
          </Button>

        </Box>
      </Box>
    );
  }
}

export default InviteTeamMembers;
